import { AgmMarkerCluster } from '@agm/js-marker-clusterer';
import { Directive, OnInit } from '@angular/core';
import 'js-marker-clusterer/src/markerclusterer.js';

declare const google;
declare const MarkerClusterer;

@Directive({
  selector: 'marker-cluster',
  outputs: ['markerClick']
})
export class MarkerClusterDirective extends AgmMarkerCluster
  implements OnInit {}
